// export default TimelineComponent;
import "@react-pdf-viewer/core/lib/styles/index.css";
import "react-calendar-timeline/dist/style.css";
import "react-quill-new/dist/quill.snow.css";
import "react-toastify/dist/ReactToastify.css";
import * as pdfjsLib from "pdfjs-dist";
import DOMPurify from "dompurify";
import Loader from "./Timelineloader";
import React, { useCallback, useEffect, useRef, useState, useMemo } from "react";
import ReactQuill from "react-quill-new";
// import Timeline from "react-calendar-timeline";
import axios from "axios";
import moment from "moment";
import pdfWorker from "pdfjs-dist/build/pdf.worker.entry";
import randomColor from "randomcolor";
import { base, faker } from "@faker-js/faker";
import { Button as Button1, Dropdown, Pagination, Table as Table1, Modal, Button } from "react-bootstrap";
import { BsFillPersonCheckFill } from "react-icons/bs";
import { FaSearch } from "react-icons/fa";
import { FiCalendar } from "react-icons/fi";
import { IoMdPrint } from "react-icons/io";
import { PiTreeViewFill } from "react-icons/pi";
import { RiTimelineView } from "react-icons/ri";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Tooltip } from "react-tooltip";
import { API_BASE_URL } from "../../../global";
import { newlineChars } from "pdf-lib";
import {
    Timeline,
    TimelineHeaders,
    DateHeader
} from "react-calendar-timeline";
import VerticalTimeline from "./verticaltimelinemodal";


pdfjsLib.GlobalWorkerOptions.workerSrc = pdfWorker;
import html2canvas from "html2canvas";
import jsPDF from "jspdf";






// overlap helpers


const PDFCanvasViewer = ({ fileUrl, pageRange = '1', scale = 1.5, selectedpdf }) => {
    const containerRef = useRef();
    const [zoom, setZoom] = useState(scale);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        let cancelled = false;
        const renderPages = async () => {
            // if (!fileUrl) return;
            if (!selectedpdf || !containerRef.current) return;

            // const loadingTask = pdfjsLib.getDocument(fileUrl);
            // const loadingTask = pdfjsLib.getDocument({
            //     url: fileUrl,
            //     withCredentials: false,
            // });
            // const pdf = await loadingTask.promise;
            if (cancelled || !containerRef.current) return;

            setLoading(true);
            const container = containerRef.current;
            container.innerHTML = '';

            let pages = [];
            if (typeof pageRange === 'string' && pageRange.includes('-')) {
                const [start, end] = pageRange.split('-').map(Number);
                pages = Array.from({ length: end - start + 1 }, (_, i) => start + i);
            } else {
                const num = parseInt(pageRange, 10);
                if (!isNaN(num)) pages = [num];
            }

            for (const pageNum of pages) {
                if (pageNum < 1 || pageNum > selectedpdf.numPages) continue;

                const page = await selectedpdf.getPage(pageNum);
                const viewport = page.getViewport({ scale: zoom });
                const wrapper = document.createElement('div');
                wrapper.style.display = 'flex';
                wrapper.style.flexDirection = 'column';
                wrapper.style.alignItems = 'center';
                wrapper.style.marginBottom = '24px';
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');
                canvas.width = viewport.width;
                canvas.height = viewport.height;

                await page.render({ canvasContext: ctx, viewport }).promise;
                const pageNumberLabel = document.createElement('div');
                pageNumberLabel.textContent = `Page ${pageNum} of ${selectedpdf.numPages}`;
                pageNumberLabel.style.marginTop = '4px';
                pageNumberLabel.style.fontSize = '14px';
                pageNumberLabel.style.color = '#555';

                wrapper.appendChild(canvas);
                wrapper.appendChild(pageNumberLabel);

                if (!cancelled) container.appendChild(wrapper);

            }
            setLoading(false);
        };
        renderPages();

        return () => {
            cancelled = true;
        };
    }, [selectedpdf, pageRange, zoom]);

    return (
        // <div>
        //     {loading && (
        //         <div style={{ textAlign: 'center', fontSize: '18px', color: '#555' }}>
        //             Loading PDF...
        //             <div className="pdfloader"></div>
        //         </div>
        //     )}
        //     <div ref={containerRef} style={{ display: 'flex', flexDirection: 'column', gap: '24px' }} />

        // </div>
        <div style={{ position: 'relative', height: '100%' }}>
            {loading && (
                <div className="pdfloader-container">
                    <div style={{ textAlign: 'center', fontSize: '18px', color: '#555' }}>
                        Loading PDF...
                    </div>
                    <div className="pdfloader"></div>
                </div>
            )}

            <div ref={containerRef} style={{ display: 'flex', flexDirection: 'column', gap: '24px' }} />
        </div>
    );
};

const SelecteditemModal = ({
    selectedItem,
    handleclose,
    caseName,
    selectedpdf
}) => {
    const [activeTab, setActiveTab] = useState("SUMMARY");
    const [itemDetails, setItemDetails] = useState(null);
    const [loading, setLoading] = useState(false);
    const [noteContent, setNoteContent] = useState("");
    const [saving, setSaving] = useState(false);
    const [hideprocess, sethideprocess] = useState(false);
    const [activeTags, setActiveTags] = useState([]);

    const [tagsInput, setTagsInput] = useState('');
    const [isedited, setisedited] = useState(false);
    const [tagtoadd, setTagToAdd] = useState(null);
    const [createdTags, setCreatedTags] = useState([]);
    const [tagtoRemove, setTagsToRemove] = useState("");
    const [tagsactivelist, setTagsactivelist] = useState([]);
    const [tagslabelOnPage, setTagslabelOnPage] = useState([]);
    const [tagsOnPage, setTagsOnPage] = useState([]);

    // Fetch details when a new item is selected

    const tabs = [
        "NOTES",
        "SUMMARY",
        "ORIGINAL IMAGE",
        "TAGS",
        "NOTES HISTORY",
        "TAGS HISTORY",
    ];



    const fetchDetails = async () => {
        try {
            setLoading(true);
            
            const caseID = localStorage.getItem("caseID");
            const response = await axios.post(`${API_BASE_URL}timeline`, {
                case_id: caseID,
                page_range: selectedItem?.caseFactPageRange,
                mode: "view_event",
                case_fact_id: selectedItem?.caseFactId,

            });


            if (response.data.status === 1) {
                setItemDetails(response.data.message);
                const allTags =
                    response?.data?.message?.timeline?.[0]?.caseFactsTags?.[0] || [];


                const activeTags = allTags.filter(
                    (tag) => tag.tagIsHistory === "0"
                );

                setTagsactivelist(activeTags);


                // Get the notes array safely
                const notes = response?.data?.message.timeline?.[0]?.caseFactsNotes?.[0] || [];

                // Find the latest note by noteCreatedOrder
                const latestNote = notes.reduce((latest, current) => {
                    return new Date(current.noteCreatedOrder) > new Date(latest.noteCreatedOrder)
                        ? current
                        : latest;
                }, notes[0]);

                // // Extract content
                const latestnotesContent = latestNote?.noteContent || "";
                setNoteContent(latestnotesContent);
            } else {
                setItemDetails(null);
            }
        } catch (err) {
            console.error("Error fetching item details:", err);
            setItemDetails(null);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (!selectedItem) return;
        fetchDetails();
        handleTagslist();
    }, [selectedItem]);

    const handleAddTag = async () => {
        if (!tagsInput.trim()) return;
        const trimmedTags = tagsInput.trim();
        if (trimmedTags.length < 3) {
            toast.warning("Please enter at least 3 characters.");
            return;
        }
        try {
            const caseID = localStorage.getItem("caseID");
            const response = await axios.post(`${API_BASE_URL}tag`, {
                case_id: caseID,
                tag: tagsInput,
                mode: "addTag"
            });
            if (response.data.status === 1) {
                const responsedata = response.data?.message || [];
                toast.success("Tag added sucessfully");
                handleTagslist();
                setTagsInput('');
            } else {
                toast.error(response.data?.message);
                setTagsInput('');
            }

        } catch (error) {
            console.error("Error in adding tags:", error);
        }
    };

    const handleTagslist = async () => {
        try {
            const caseID = localStorage.getItem("caseID");
            const response = await axios.post(`${API_BASE_URL}tag`, {
                case_id: caseID,
                mode: "listAllTag",
                get_type: "all_tags"
            });
            if (response.data.status === 1) {
                const responsedata = response.data?.message?.all_tags || [];

                if (Array.isArray(responsedata)) {
                    setCreatedTags(responsedata);
                } else {
                    setCreatedTags([]);
                }
            }
        } catch (error) {
            console.error("Error fetching saved search data:", error);
        }
    };

    const handletagenablesubmit = async () => {
        setisedited(true);
        try {
            const caseID = localStorage.getItem("caseID");
            let firstPage = selectedItem?.caseFactPageRange;
            if (typeof firstPage === "string" && firstPage.includes("-")) {
                firstPage = firstPage.split("-")[0];
            }

            const response = await axios.post(`${API_BASE_URL}tag`, {
                case_id: caseID,
                page_no: firstPage,
                tag_id: tagtoadd,
                mode: "editTag",
                edit_type: "active",
            });

            if (response.data.status === 1) {
                toast.success("Tags updated successfully.");
                fetchDetails();
                handleTagslist();
                setTagToAdd(null);
            } else {
                toast.error("Failed to update tags.");
            }

        } catch (error) {
            console.error("Error updating tags:", error);
            toast.error("An error occurred while updating tags.");
        }
    };
    const handletagremovesubmit = async () => {

        try {
            const caseID = localStorage.getItem("caseID");
            const Page = selectedItem?.caseFactPageRange;

            const response = await axios.post(`${API_BASE_URL}tag`, {
                case_id: caseID,
                page_range: Page,
                tag_id: tagtoRemove,
                mode: "editTag",
                edit_type: "remove"

            });

            if (response.data.status === 1) {
                toast.success("Tags Removed successfully.");
                fetchDetails();
                handleTagslist();
            } else {
                toast.error("Failed to remove tags.");
            }

        } catch (error) {
            console.error("Error updating tags:", error);
            toast.error("An error occurred while updating tags.");
        }
    };

    const tagsPerPage = 5;
    const [tagscurrentPage, setTagsCurrentPage] = useState(1);
    const [TagspageNumbers, setTagspageNumbers] = useState([]);
    const filteredTags = itemDetails?.timeline[0]?.caseFactsTags[0]
        ?.filter(tag => tag.tagIsHistory === "1") || [];

    const totalTags = filteredTags?.length;
    const totalTagPages = Math.ceil(totalTags / tagsPerPage);

    // Get the tags to be displayed on the current page
    const displayedTags = filteredTags.slice(
        (tagscurrentPage - 1) * tagsPerPage,
        tagscurrentPage * tagsPerPage
    );

    // Generate page numbers for pagination with ellipses
    const generateTagsPageNumbers = () => {
        const range = [];

        if (totalTagPages <= 5) {
            for (let i = 1; i <= totalTagPages; i++) {
                range.push(i);
            }
        } else {
            const leftEllipsis = tagscurrentPage > 3;
            const rightEllipsis = tagscurrentPage < totalTagPages - 2;

            if (leftEllipsis) range.push(1);
            if (leftEllipsis && tagscurrentPage > 2) range.push("...");

            const start = Math.max(1, tagscurrentPage - 2);
            const end = Math.min(totalTagPages, tagscurrentPage + 2);

            for (let i = start; i <= end; i++) {
                range.push(i);
            }

            if (rightEllipsis && tagscurrentPage < totalTagPages - 2) range.push("...");
            if (rightEllipsis) range.push(totalTagPages);
        }

        setTagspageNumbers(range);
    };

    // Call to generate page numbers whenever the page changes
    useEffect(() => {
        generateTagsPageNumbers();
    }, [tagscurrentPage, totalTagPages]);

    // Handle pagination click
    const tagspaginate = (pageNumber) => {
        if (pageNumber === "...") return;
        setTagsCurrentPage(pageNumber);
    };

    // Handle fast backward (skip to first page)
    const tagsfastBackward = () => {
        setTagsCurrentPage(1);
    };

    // Handle fast forward (skip to last page)
    const tagsfastForward = () => {
        setTagsCurrentPage(totalTagPages);
    };

    //note tag and note history tab start
    const handleNoteSubmit = async () => {
        if (saving || !noteContent.trim()) return;
        const trimmedNote = noteContent.trim();
        if (trimmedNote.length < 5) {
            toast.warning("Please enter at least 5 characters.");
            return;
        }
        setSaving(true);
        setisedited(true);
        let firstPage = selectedItem?.caseFactPageRange;
        if (typeof firstPage === "string" && firstPage.includes("-")) {
            firstPage = firstPage.split("-")[0]; // take "1" from "1-3"
        }

        try {
            const caseID = localStorage.getItem("caseID");
            const response = await axios.post(`${API_BASE_URL}note`, {
                case_id: caseID,
                page_no: firstPage,
                note: noteContent,
                mode: "addNote",
                is_timeline: 1
            });

            if (response.data.status === 1) {
                toast.success("Notes added sucessfully");
                handleclose(true);

            } else {
                toast.error(response.data?.message);
            }
        } catch (err) {
            console.error("Error saving note:", err);

        } finally {
            setSaving(false);
        }
    };
    const notesPerPage = 5;
    const [notescurrentPage, setNotesCurrentPage] = useState(1);
    const [NotespageNumbers, setNotespageNumbers] = useState([]);

    const totalNotes = itemDetails?.timeline[0]?.caseFactsNotes[0]?.length;
    const totalNotePages = Math.ceil(totalNotes / notesPerPage);

    // Get the notes to be displayed on the current page
    const displayedNotes = itemDetails?.timeline[0]?.caseFactsNotes[0]?.slice(
        (notescurrentPage - 1) * notesPerPage,
        notescurrentPage * notesPerPage
    );

    // Generate page numbers for pagination with ellipses
    const generateNotesPageNumbers = () => {
        const range = [];

        if (totalNotePages <= 5) {
            for (let i = 1; i <= totalNotePages; i++) {
                range.push(i);
            }
        } else {
            const leftEllipsis = notescurrentPage > 3;
            const rightEllipsis = notescurrentPage < totalNotePages - 2;

            if (leftEllipsis) range.push(1);
            if (leftEllipsis && notescurrentPage > 2) range.push("...");

            const start = Math.max(1, notescurrentPage - 2);
            const end = Math.min(totalNotePages, notescurrentPage + 2);

            for (let i = start; i <= end; i++) {
                range.push(i);
            }

            if (rightEllipsis && notescurrentPage < totalNotePages - 2) range.push("...");
            if (rightEllipsis) range.push(totalNotePages);
        }

        setNotespageNumbers(range);
    };

    // Call to generate page numbers whenever the page changes
    useEffect(() => {
        generateNotesPageNumbers();
    }, [notescurrentPage, totalNotePages]);

    // Handle pagination click
    const notespaginate = (pageNumber) => {
        if (pageNumber === "...") return;
        setNotesCurrentPage(pageNumber);
    };

    // Handle fast backward (skip to first page)
    const notesfastBackward = () => {
        setNotesCurrentPage(1);
    };

    // Handle fast forward (skip to last page)
    const notesfastForward = () => {
        setNotesCurrentPage(totalNotePages);
    };
    //note tag and note history tab end

    const handlereporthide = async () => {
        setisedited(true);
        sethideprocess(true);
        try {
            const caseID = localStorage.getItem("caseID");
            const response = await axios.post(`${API_BASE_URL}timeline`, {
                case_id: caseID,
                case_fact_id: itemDetails?.timeline[0]?.caseFactId,
                is_hide: itemDetails?.timeline[0]?.caseFactIsHide === 1 ? 0 : 1,
                mode: "hide_event",
            });

            if (response.data.status === 1) {
                toast.success("Report Updated successfully.");
                // fetchDetails();
                // handleTagslist();
                sethideprocess(false);
                setTimeout(() => {
                    handleclose(true);
                }, 1000);

            } else {
                sethideprocess(false);
                toast.error("Failed to remove report.");
            }

        } catch (error) {
            sethideprocess(false);
            console.error("Error updating report:", error);
            toast.error("An error occurred while updating report.");
        }
    };

    if (!selectedItem) return null;

    return (
        <div className="tls-modal-backdrop">
            <div className="tls-modal" onClick={(e) => e.stopPropagation()}>


                <button
                    className="tls-modal__close"
                    onClick={() => handleclose(isedited)}
                    aria-label="Close"
                >
                    ✖
                </button>

                <div className="tls-modal__tabs">
                    {tabs.map((tab) => (
                        <div
                            key={tab}
                            className={`tls-modal__tab ${activeTab === tab ? "tls-modal__tab--active" : ""
                                }`}
                            onClick={() => setActiveTab(tab)}
                        >
                            {tab}
                        </div>
                    ))}

                    <div className="tls-modal__badge">
                        {activeTab !== "SUMMARY" &&
                            itemDetails?.timeline[0]?.caseFactIsHide === 0 ? (
                            <span className="badge badge-danger">Hidden</span>
                        ) : (
                            null
                        )}

                    </div>
                </div>

                <div className="tls-modal__metadata">
                    <div className="tls-meta-left">
                        <div className="tls-meta-date">
                            {itemDetails ? moment(itemDetails?.timeline[0]?.caseFactDate).format("MMM D, YYYY") : "—"}
                        </div>
                        <div className="tls-meta-title">
                            {/* Example: Primary Treating Physician's Progress Report */}
                            {itemDetails ? itemDetails?.timeline[0]?.caseFactTitle : ""}
                        </div>
                    </div>

                    <div className="tls-meta-right">
                        <span className="tls-meta-pill">
                            <b>Provider</b> (<span className="tls-meta-highlight">{itemDetails ? itemDetails?.timeline[0]?.caseFactProvider : "—"}</span>)
                        </span>
                        <span className="tls-meta-pill">
                            <b>Page Range</b> (<span className="tls-meta-highlight">{itemDetails ? itemDetails?.timeline[0]?.caseFactPageRange : "—"}</span>)
                        </span>
                        <span className="tls-meta-pill">
                            <b>Organization</b> (<span className="tls-meta-highlight">{itemDetails ? itemDetails?.timeline[0]?.caseFactOrg : "—"}</span>)
                        </span>
                    </div>
                </div>


                <div className="tls-modal__body">
                    {activeTab === "NOTES" && (
                        <div>
                            <div className="tls-notes">
                                <ReactQuill
                                    className="tls-notes__editor"
                                    value={noteContent}
                                    onChange={setNoteContent}
                                    // onChange={(content, delta, source, editor) => {
                                    //     setNoteContent(editor.getText()); // plain text only
                                    // }}

                                    placeholder="Write your notes here..."
                                    modules={{
                                        toolbar: [
                                            ["bold", "italic", "underline", "strike"],
                                            [{ header: [false, 3, 4, 5, 6] }],
                                            [{ list: "ordered" }, { list: "bullet" }],
                                            [{ color: [] }, { background: [] }],
                                            ["clean"],
                                        ],
                                    }}
                                    formats={[
                                        "bold",
                                        "italic",
                                        "underline",
                                        "strike",
                                        "header",
                                        "list",
                                        "bullet",
                                        "color",
                                        "background",
                                    ]}
                                />


                            </div>
                            <div className="tls-notes__footer">
                                <button
                                    className="tls-btn tls-btn--save mt-2"
                                    onClick={handleNoteSubmit}
                                    disabled={saving}
                                >
                                    {saving ? "Saving..." : "Save"}
                                </button>
                            </div>
                        </div>
                    )}

                    {activeTab === "SUMMARY" && (
                        <>
                            <p
                                className="no-copy"
                                onCopy={(e) => e.preventDefault()}
                                onCut={(e) => e.preventDefault()}
                                onPaste={(e) => e.preventDefault()}
                                onMouseDown={(e) => e.preventDefault()}  // stop drag selection
                                onDragStart={(e) => e.preventDefault()}  // stop drag events
                            >
                                {itemDetails?.timeline[0]?.caseFactsSummary || "Summary Not Available"}
                            </p>

                        </>
                    )}
                    {activeTab === "ORIGINAL IMAGE" && (
                        <>
                            <PDFCanvasViewer
                                fileUrl={itemDetails?.pdfUrl}
                                pageRange={itemDetails?.timeline[0]?.caseFactPageRange || '1'}
                                scale={1.5}
                                selectedpdf={selectedpdf}
                            />
                        </>
                    )}
                    {activeTab === "TAGS" && (
                        <div className="tls-tags">
                            <div className="tls-tags__add">
                                <select value={tagtoadd}
                                    onChange={(e) => {
                                        setTagToAdd(e.target.value)
                                        setTagsOnPage((prev) => [...prev, e.target.value])
                                    }
                                    }>
                                    <option value="">--Select Tag--</option>
                                    {createdTags
                                        .filter(
                                            (tag) => !tagsactivelist.some((activeTag) => String(activeTag.tagId) === String(tag.tagId))
                                        )
                                        .map((tag, i) => (
                                            <option key={tag.tagId} value={tag.tagId}>
                                                {tag.tagContent}
                                            </option>
                                        ))}
                                </select>

                                <button
                                    className="tls-btn tls-btn--add "
                                    onClick={() => handletagenablesubmit()}
                                >
                                    Add
                                </button>
                                OR
                                <input
                                    type="text"
                                    placeholder="Custom Tags here"
                                    value={tagsInput}
                                    onChange={(e) => setTagsInput(e.target.value)}
                                />
                                <button
                                    className="tls-btn tls-btn--add"
                                    onClick={() => handleAddTag()}
                                >
                                    Add
                                </button>
                            </div>

                            <div className="tls-tags__remove">
                                <select value={tagtoRemove}
                                    onChange={(e) => {
                                        const selectedTag = e.target.value;
                                        setTagsToRemove(selectedTag);
                                        // setTagsOnPage((prev) => prev.filter((t) => t !== Number(selectedTag)));
                                    }
                                    }>
                                    <option value="">--Select Tag--</option>
                                    {tagsactivelist.map((tag, i) => (
                                        <option key={tag.tagId} value={tag.tagId}>
                                            {tag.tagName}
                                        </option>
                                    ))}
                                </select>
                                <button
                                    className="tls-btn tls-btn--remove"
                                    onClick={() => handletagremovesubmit()}
                                >
                                    Remove
                                </button>
                            </div>

                            <div className="tls-tags__active">
                                <b>Active Tags</b>
                                {/* <p>({tagslabelOnPage.length ? tagslabelOnPage.join(", ") : ""})</p> */}
                                <p>
                                    ({tagsactivelist.length > 0
                                        ? tagsactivelist.map(tag => tag.tagName).join(", ")
                                        : ""})
                                </p>

                            </div>
                        </div>
                    )}
                    {activeTab === "NOTES HISTORY" && (
                        <div className="tls-notes-history">
                            <h4>Notes History ({itemDetails?.timeline[0]?.caseFactsNotes[0]?.length || 0})</h4>

                            <Table1 hover>
                                <thead className="custom-header-border">
                                    <tr >
                                        <th className="center-text">S. No.</th>
                                        <th className="center-text" >Notes</th>
                                        <th className="center-text" >Created Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {displayedNotes?.length > 0 ? (
                                        displayedNotes.map((note, index) => (
                                            <tr key={note.noteId} className="custom-row-border" onClick={() => handlenoteSearch(note.noteId)}>
                                                <td className="center-text">
                                                    {(notescurrentPage - 1) * notesPerPage + (index + 1)}
                                                </td>
                                                {/* <td className="wrap-text" >{note?.noteContent || ""}</td> */}
                                                <td
                                                    className="wrap-text"
                                                    dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(note?.noteContent || "") }}
                                                ></td>

                                                <td className="center-text">{note.noteCreated}</td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="5" className="text-center text-muted py-3">
                                                No notes available
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </Table1>

                            {/* Pagination */}
                            <Pagination className=" justify-content-end mt-1 custom-pagination-timeline">
                                <Pagination.First onClick={notesfastBackward} disabled={notescurrentPage === 1} />
                                <Pagination.Prev onClick={() => notespaginate(notescurrentPage - 1)} disabled={notescurrentPage === 1} />
                                {NotespageNumbers.map((number, idx) => (
                                    <Pagination.Item
                                        key={idx}
                                        active={number === notescurrentPage}
                                        onClick={() => notespaginate(number)}
                                    >
                                        {number}
                                    </Pagination.Item>
                                ))}
                                <Pagination.Next onClick={() => notespaginate(notescurrentPage + 1)} disabled={notescurrentPage === NotespageNumbers[NotespageNumbers.length - 1]} />
                                <Pagination.Last onClick={notesfastForward} disabled={notescurrentPage === NotespageNumbers[NotespageNumbers.length - 1]} />
                            </Pagination>
                        </div>
                    )}
                    {activeTab === "TAGS HISTORY" && (
                        <div className="tls-tags-history">
                            <h4>Tags History ({itemDetails?.timeline[0]?.caseFactsTags[0]?.length || 0})</h4>

                            <Table1 hover>
                                <thead className="custom-header-border">
                                    <tr >
                                        <th className="center-text">S. No.</th>
                                        <th className="center-text" >Tags</th>
                                        <th className="center-text" >Created Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {displayedTags?.length > 0 ? (
                                        displayedTags.map((tag, index) => (
                                            <tr key={tag.tagId + index} className="custom-row-border">
                                                <td className="center-text">
                                                    {(tagscurrentPage - 1) * tagsPerPage + (index + 1)}
                                                </td>
                                                <td className="wrap-text" >{tag?.tagName || ""}</td>
                                                <td className="center-text">{tag.tagCreated}</td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="5" className="text-center text-muted py-3">
                                                No tags available
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </Table1>

                            {/* Pagination */}
                            <Pagination className="custom-pagination-timeline justify-content-end mt-1">
                                <Pagination.First onClick={tagsfastBackward} disabled={tagscurrentPage === 1} />
                                <Pagination.Prev onClick={() => tagspaginate(tagscurrentPage - 1)} disabled={tagscurrentPage === 1} />
                                {TagspageNumbers.map((number, idx) => (
                                    <Pagination.Item
                                        key={idx}
                                        active={number === tagscurrentPage}
                                        onClick={() => tagspaginate(number)}
                                    >
                                        {number}
                                    </Pagination.Item>
                                ))}
                                <Pagination.Next onClick={() => tagspaginate(tagscurrentPage + 1)} disabled={tagscurrentPage === TagspageNumbers[TagspageNumbers.length - 1]} />
                                <Pagination.Last onClick={tagsfastForward} disabled={tagscurrentPage === TagspageNumbers[TagspageNumbers.length - 1]} />
                            </Pagination>
                        </div>
                    )}
                </div>
                <div className="tls-modal__footer d-flex justify-content-end">
                    {activeTab === "SUMMARY" && (
                        <button
                            className="tls-btn tls-btn--toggle mt-3"
                            onClick={() => handlereporthide()}
                            disabled={hideprocess}
                        >
                            {hideprocess
                                ? "Processing..."
                                : itemDetails?.timeline[0]?.caseFactIsHide === 0
                                    ? "Unhide Report"
                                    : "Hide Report"}
                        </button>
                    )}
                </div>
            </div>
        </div >
    );
};

const adjustItemsToAvoidOverlap = (items) => {
    const groupedByDay = {};

    return items.map((item) => {
        const dayKey = moment(item.start).format("YYYY-MM-DD");

        if (!groupedByDay[dayKey]) {
            groupedByDay[dayKey] = 0;
        }

        const slotIndex = groupedByDay[dayKey];
        groupedByDay[dayKey] += 1;

        const duration = moment(item.end).diff(moment(item.start), "ms");

        // Sequential hourly slot: 12 items per hour
        const hourSlot = Math.floor(slotIndex / 12);

        const newStart = moment(dayKey)
            .startOf("day")
            .add(hourSlot, "hours");

        const newEnd = newStart.clone().add(duration, "ms");

        return { ...item, start: newStart.valueOf(), end: newEnd.valueOf() };
    });
};

const getEffectiveEnd = (item, pixelsPerMs, cache) => {
    if (cache.has(item)) return cache.get(item);

    const labelLength = item.caseFactLabel ? item.caseFactLabel.length + 17 : 0;
    const minWidth = Math.max(100, labelLength * 7);
    const effectiveEnd = item.end + minWidth / pixelsPerMs;

    cache.set(item, effectiveEnd);
    return effectiveEnd;
};

const regroupItems = (items, pixelsPerMs) => {
    const effectiveEndCache = new WeakMap();
    const groups = [];
    const groupEnds = []; // stores max effectiveEnd of last item in each group
    const placedItems = [];

    // Sort items by start time (in place)
    items.sort((a, b) => a.start - b.start);

    for (const item of items) {
        const itemStart = item.start;
        const itemEffectiveEnd = getEffectiveEnd(item, pixelsPerMs, effectiveEndCache);

        // Find a group that can fit this item (whose last effective end <= item start)
        let assignedGroupIndex = -1;

        for (let i = 0; i < groupEnds.length; i++) {
            if (groupEnds[i] <= itemStart) {
                assignedGroupIndex = i;
                break;
            }
        }

        // If no group fits, create new one
        if (assignedGroupIndex === -1) {
            assignedGroupIndex = groups.length;
            groups.push({
                id: (assignedGroupIndex + 1).toString(),
                title: `Row ${assignedGroupIndex + 1}`,
                rightTitle: "Auto"
            });
            groupEnds.push(0); // placeholder, will update below
        }

        // Assign item to group
        groupEnds[assignedGroupIndex] = itemEffectiveEnd;
        placedItems.push({ ...item, group: groups[assignedGroupIndex].id });
    }

    return { groups, items: placedItems };
};

const regroupWithCollapse = (items, pixelsPerMs, MAX_VISIBLE_GROUPS) => {
    const { groups, items: placedItems } = regroupItems(items, pixelsPerMs);

    if (groups.length <= MAX_VISIBLE_GROUPS) {
        return { groups, items: placedItems };
    }

    const collapsedGroupId = "collapsed";
    const collapsedGroup = {
        id: collapsedGroupId,
        title: "Other Items",
        rightTitle: "…",
        collapsed: true
    };

    const visibleGroups = groups.slice(0, MAX_VISIBLE_GROUPS - 1);
    const visibleGroupIds = new Set(visibleGroups.map(g => g.id));

    const updatedItems = placedItems.map(item =>
        visibleGroupIds.has(item.group)
            ? item
            : { ...item, group: collapsedGroupId }
    );

    return {
        groups: [...visibleGroups, collapsedGroup],
        items: updatedItems
    };
};



const keys = {
    groupIdKey: "id",
    groupTitleKey: "title",
    groupRightTitleKey: "rightTitle",
    itemIdKey: "id",
    itemTitleKey: "title",
    itemDivTitleKey: "title",
    itemGroupKey: "group",
    itemTimeStartKey: "start",
    itemTimeEndKey: "end",
    groupLabelKey: "title",
};

const TimelineComponent = () => {

    const navigate = useNavigate();
    // const minTime = moment().startOf("month").valueOf();
    // const maxTime = moment().endOf("month").valueOf();
    // const defaultTimeStart = moment().startOf("week").valueOf();
    // const defaultTimeEnd = moment().endOf("week").valueOf();
    const [defaultTimeStart, setdefaultTimeStart] = useState(moment().startOf("week").valueOf());
    const [defaultTimeEnd, setdefaultTimeEnd] = useState(moment().endOf("week").valueOf());
    const [minTime, setminTime] = useState(moment().startOf("month").valueOf());
    const [maxTime, setmaxTime] = useState(moment().endOf("month").valueOf());
    const [visibleTimeEnd, setVisibleTimeEnd] = useState(null);
    const [visibleTimeStart, setVisibleTimeStart] = useState(null);
    const [caseName, setCaseName] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");
    const [ogbaseItems, setogbaseItems] = useState([]);
    const [baseItems, setbaseItems] = useState([]);
    const [searchstate, setsearchstate] = useState(false);

    // const [groups, setGroups] = useState([]);
    // const [items, setItems] = useState([]);
    const [selectedItem, setSelectedItem] = useState(null);
    const [onclickdisable, setonclickdisable] = useState(null);
    const [sliderValue, setSliderValue] = useState(0);
    const [isloading, setloading] = useState(true);

    //filter functionality state start
    const [selectedProviders, setSelectedProviders] = useState([]); //add
    const prevProvidersRef = useRef([]); //add
    const [visibilityFilter, setVisibilityFilter] = useState('all'); // 'all' | 'hidden' | 'visible'
    const [startDateFilter, setStartDateFilter] = useState('');
    const [endDateFilter, setEndDateFilter] = useState('');
    const [searchKeywords, setSearchKeywords] = useState('');
    // Filters Popup                                          //add
    const [isProviderPopupOpen, setProviderPopupOpen] = useState(false);
    const [isStatusPopupOpen, setStatusPopupOpen] = useState(false);
    const [isDatePopupOpen, setDatePopupOpen] = useState(false);
    const [searchPopupOpen, setSearchPopupOpen] = useState(false);
    const [searchfilters, setSearchFilters] = useState({
        title: true,
        provider: false,
        organization: false,
    });


    //filter functionality state end

    const [fileUrl, setfileUrl] = useState(null);
    const [pdf, setPdf] = useState(null);



    const timelineRef = useRef(null);
    const OveralltimelineRef = useRef(null);
    const headerRef = useRef(null);
    const isDraggingRef = useRef(false);

    const dragState = useRef({ isDragging: false, startX: 0, startVisibleStart: 0, startVisibleEnd: 0 });
    const dragFrame = useRef(null);

    const handlePrint12 = async () => {
        const timelineElement = OveralltimelineRef.current;

        if (!timelineElement) return;

        try {
            // Capture as canvas
            const noPrintElements = timelineElement.querySelectorAll(".no-print");
            noPrintElements.forEach(el => (el.style.visibility = "hidden"));

            const canvas = await html2canvas(timelineElement, {
                useCORS: true, // if you have external resources like images/fonts
                scale: 2, // for higher resolution
            });
            noPrintElements.forEach(el => (el.style.visibility = "visible"));
            const imgData = canvas.toDataURL("image/png");
            const pdf = new jsPDF({
                orientation: "landscape",
                unit: "px",
                format: [canvas.width, canvas.height], // exact size
            });

            pdf.addImage(imgData, "PNG", 0, 0, canvas.width, canvas.height);
            // pdf.save("timeline-view.pdf");
            pdf.autoPrint();

            // Open PDF in a new window and trigger print
            const pdfBlobUrl = pdf.output('bloburl');
            window.open(pdfBlobUrl);
        } catch (err) {
            console.error("Error generating PDF:", err);
        }
    };
    const [previewImg, setPreviewImg] = useState(null);
    const [showPreview, setShowPreview] = useState(false);
    const handlePreview = async () => {
        const timelineElement = OveralltimelineRef.current;
        if (!timelineElement) return;

        try {
            const noPrintElements = timelineElement.querySelectorAll(".no-print");
            noPrintElements.forEach(el => (el.style.visibility = "hidden"));

            const canvas = await html2canvas(timelineElement, {
                useCORS: true,
                scale: 2,
            });

            noPrintElements.forEach(el => (el.style.visibility = "visible"));
            let imgData = canvas.toDataURL("image/png");
            setPreviewImg(imgData);
            setShowPreview(true);
        } catch (err) {
            console.error("Error generating preview:", err);
        }
    };

    const handlePrint = () => {
        if (!previewImg) return;
        setShowPreview(false);
        // Create a temporary print container
        const printContainer = document.createElement("div");
        printContainer.id = "print-container";
        printContainer.style.textAlign = "center";
        printContainer.style.padding = "20px";
        printContainer.innerHTML = `<img src="${previewImg}" style="max-width:100%; height:auto;" />`;

        // Add to body
        document.body.appendChild(printContainer);

        // Add print styles
        const style = document.createElement("style");
        style.textContent = `
                            @media print {
                            body * {
                                visibility: hidden;
                            }
                            #print-container, #print-container * {
                                visibility: visible;
                            }
                            #print-container {
                                position: absolute;
                                left: 0;
                                top: 0;
                                width: 100%;
                                text-align: center;
                                -webkit-print-color-adjust: exact;
                                color-adjust: exact;
                            }
                            img {
                                page-break-inside: avoid;
                                max-width: 100%;
                            }
                            }
                        `;
        document.head.appendChild(style);

        //trigger Native print (Ctrl + P)
        window.print();

        // Cleanup after print
        document.body.removeChild(printContainer);
        document.head.removeChild(style);
        setPreviewImg(null);
    };

    useEffect(() => {
        const header = headerRef.current;
        if (!header) return;
        isDraggingRef.current = true;
        let moved = false;
        const onMouseDown = (e) => {
            dragState.current.isDragging = true;
            dragState.current.startX = e.clientX;
            dragState.current.startVisibleStart = visibleTimeStart;
            dragState.current.startVisibleEnd = visibleTimeEnd;
            isDraggingRef.current = false;
        };

        const onMouseMove = (e) => {
            if (!dragState.current.isDragging) return;
            moved = true;
            isDraggingRef.current = true;
            const deltaX = e.clientX - dragState.current.startX;

            const timelineWidth =
                timelineRef.current?.container?.clientWidth || window.innerWidth;
            const deltaTime = (-deltaX / timelineWidth) * (visibleTimeEnd - visibleTimeStart);

            let newStart = dragState.current.startVisibleStart + deltaTime;
            let newEnd = dragState.current.startVisibleEnd + deltaTime;

            if (newStart < minTime) {
                newStart = minTime;
                newEnd = minTime + (visibleTimeEnd - visibleTimeStart);
            }
            if (newEnd > maxTime) {
                newEnd = maxTime;
                newStart = maxTime - (visibleTimeEnd - visibleTimeStart);
            }

            // setVisibleTimeStart(newStart);
            // setVisibleTimeEnd(newEnd);
            if (!dragFrame.current) {
                dragFrame.current = requestAnimationFrame(() => {
                    setVisibleTimeStart(newStart);
                    setVisibleTimeEnd(newEnd);
                    dragFrame.current = null;
                });
            }
        };

        const onMouseUp = () => {
            if (!moved) {
                // 👉 was just a click, do nothing
                // console.log("Click ignored");
            }
            dragState.current.isDragging = false;
            // reset drag flag after short delay so click doesn't fire
            setTimeout(() => {
                isDraggingRef.current = false;
            }, 0);
        };

        header.addEventListener("mousedown", onMouseDown);
        window.addEventListener("mousemove", onMouseMove);
        window.addEventListener("mouseup", onMouseUp);

        return () => {
            header.removeEventListener("mousedown", onMouseDown);
            window.removeEventListener("mousemove", onMouseMove);
            window.removeEventListener("mouseup", onMouseUp);
        };
    }, [visibleTimeStart, visibleTimeEnd]);

    useEffect(() => {
        if (visibleTimeStart === null && visibleTimeEnd === null) {
            const start = minTime;
            const end = moment(minTime).add(7, "days").valueOf();
            setVisibleTimeStart(start);
            setVisibleTimeEnd(end);
        }
        const value = Math.min(
            100,
            Math.max(
                0,
                100 - ((visibleTimeEnd - visibleTimeStart) / (maxTime - minTime)) * 100
            )
        );
        setSliderValue(value);
    }, [visibleTimeStart, visibleTimeEnd, minTime]);

    // const [groups, setGroups] = useState([]);
    // const [items, setItems] = useState([]);
    const { groups, items } = useMemo(() => {
        if (visibleTimeStart === null || visibleTimeEnd === null) {
            // Return empty arrays if the visible time is not yet set
            return { groups: [], items: [] };
        }

        if (visibleTimeStart !== null && visibleTimeEnd !== null) {
            const timelineWidth =
                timelineRef.current?.container?.clientWidth || window.innerWidth;
            const pixelsPerMs = timelineWidth / (visibleTimeEnd - visibleTimeStart);
            let containerHeight = timelineRef.current?.container?.clientHeight || 0;
            const scrollableDiv = document.querySelector('.rct-scroll');

            if (scrollableDiv) {
                containerHeight = scrollableDiv.clientHeight;
                // console.log("Container Height:", scrollableDiv.clientHeight);
            } else {
                // console.log("Scroll div not found!");
            }
            const groupHeight = 45;
            const dynamicMaxVisibleGroups = Math.floor(containerHeight / groupHeight);

            const MAX_VISIBLE_GROUPS = Math.max(5, Math.min(dynamicMaxVisibleGroups, 20));
            const result = regroupWithCollapse(
                baseItems,
                pixelsPerMs,
                MAX_VISIBLE_GROUPS,
                visibleTimeStart,
                visibleTimeEnd
            );
            // setGroups(newGroups);
            // setItems(newItems);
            return result;
        }
    }, [baseItems, visibleTimeStart, visibleTimeEnd]);


    const handleSliderChange = (e) => {
        setSliderValue(Number(e.target.value)); // just move the thumb
    };

    const handleSliderCommit = (value) => {
        const percent = (100 - value) / 100;
        const total = maxTime - minTime;
        const newRange = total * percent;
        const center = (visibleTimeStart + visibleTimeEnd) / 2;

        let newStart = center - newRange / 2;
        let newEnd = center + newRange / 2;

        if (newStart < minTime) {
            newStart = minTime;
            newEnd = minTime + newRange;
        }
        if (newEnd > maxTime) {
            newEnd = maxTime;
            newStart = maxTime - newRange;
        }

        setVisibleTimeStart(newStart);
        setVisibleTimeEnd(newEnd);
    };

    const itemRenderer = ({ item, itemContext, getItemProps, getResizeProps, selectedItem }) => {
        const { left: leftResizeProps, right: rightResizeProps } = getResizeProps();
        const isCollapsedGroup = item.group === "collapsed";

        const backgroundColor = selectedItem?.id
            ? item.selectedBgColor
            : item.bgColor;
        const titleLength = item.title.length;
        let dynamicHeight;
        if (isCollapsedGroup) {
            dynamicHeight = 40;
        } else {
            dynamicHeight = 60 + Math.floor(titleLength / 20) * 30;
        }
        // const minWidth = Math.max(100, titleLength * 8);
        const titlelabeLength = item.caseFactLabel.length;

        const minWidth = Math.max(100, titlelabeLength * 7);
        // console.log("Item:", item);
        // console.log("Title length:", titlelabeLength, "=> minWidth:", minWidth);


        const itemProps1 = getItemProps({
            style: {
                backgroundColor,
                color: item.color,
                borderStyle: "solid",
                borderTopWidth: 1,
                borderBottomWidth: 1,
                borderLeftWidth: selectedItem?.id ? 3 : 1,
                borderRightWidth: selectedItem?.id ? 3 : 1,
                borderRadius: 4,
                height: dynamicHeight,
                minWidth: !isCollapsedGroup ? minWidth + 30 : 0,
                position: "relative",
                overflow: "visible",
            },
            title: ""
        });
        const dynamicTop = itemContext?.dimensions?.top || 0;
        const itemProps = getItemProps({
            style: {
                backgroundColor: isCollapsedGroup ? "transparent" : backgroundColor,
                color: item.color,
                borderStyle: isCollapsedGroup ? "none" : "solid",
                borderTopWidth: isCollapsedGroup ? 0 : 1,
                borderBottomWidth: isCollapsedGroup ? 0 : 1,
                borderLeftWidth: isCollapsedGroup ? 0 : (selectedItem?.id ? 3 : 1),
                borderRightWidth: isCollapsedGroup ? 0 : (selectedItem?.id ? 3 : 1),
                borderRadius: isCollapsedGroup ? "50%" : 4, // make it compact when collapsed
                height: isCollapsedGroup ? 40 : dynamicHeight,
                minWidth: isCollapsedGroup ? 0 : minWidth + 30,
                width: isCollapsedGroup ? 40 : "auto", // force small square when collapsed
                position: "relative",
                overflow: "visible",
                display: "flex",
                alignItems: "center",
                top: 'auto',
                bottom: `${dynamicTop}px`
                // justifyContent: "center",
            },
            title: ""
        });


        const { key, ...restItemProps } = itemProps;

        return (
            <>
                <div
                    key={item.id}
                    {...restItemProps}
                    onClick={(e) => {
                        if (onclickdisable) return;
                        e.stopPropagation();
                        setSelectedItem(item);
                    }}
                    title={undefined}
                    data-tooltip-id={`tooltip-${item.id}`}

                    data-tooltip-html={`
                        <strong>Date:</strong> ${moment(item?.start).format("MMM DD, YYYY")}<br/>
                        <strong>Provider:</strong> ${item?.caseFactProvider || 'N/A'}<br/>
                        <strong>Organization:</strong>  ${item?.caseFactOrg || 'N/A'}<br/>
                        <strong>Page Range:</strong> ${item?.caseFactPageRange || 'N/A'}
                    `}

                >
                    {itemContext.useResizeHandle ? <div {...leftResizeProps} /> : null}

                    {/* Render random shape */}
                    <span
                        style={{
                            position: "absolute",
                            left: -25,
                            fontSize: "16px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            display: "inline-block",
                            width: !isCollapsedGroup ? 20 : 10,
                            height: !isCollapsedGroup ? 20 : 10,
                            backgroundColor: item.shapeColor, // Shape color
                            borderRadius: item.shape === "circle" ? "50%" : "0%", // Circle or Square
                            clipPath:
                                item.shape === "triangle"
                                    ? "polygon(50% 0%, 0% 100%, 100% 100%)"
                                    : item.shape === "star"
                                        ? "polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%)"
                                        : "none",
                        }}
                    >
                    </span>

                    <div
                        style={{
                            height: 26,
                            overflow: "hidden",
                            // paddingLeft: 6,
                            // paddingRight: 6,
                            // textOverflow: "ellipsis",
                            // whiteSpace: "nowrap",
                            overflow: "visible",    // allow full text
                            whiteSpace: "normal",
                        }}

                    >
                        {item.group !== "collapsed" ? (
                            <span style={{ color: "#555", fontSize: "12px", marginLeft: "6px" }}>
                                {itemContext.title}
                            </span>
                        ) : ""}


                        {item.caseFactIsHide === 0 && !isCollapsedGroup && (
                            <span className="timeline-hide-badge">H</span>
                        )}
                        {item.tagIsTimeline === 1 && !isCollapsedGroup && (
                            <span className="timeline-hide-badge">T</span>
                        )}
                        {item.noteIsTimeline === 1 && !isCollapsedGroup && (
                            <span className="timeline-hide-badge">N</span>
                        )}
                    </div>

                    {itemContext.useResizeHandle ? <div {...rightResizeProps} /> : null}
                </div>

                {/* Using Tooltip component */}
                {!isCollapsedGroup && (

                    <Tooltip id={`tooltip-${item.id}`} place="top" multiline={true} className="custom-tooltip_timeline" html delayShow={300} />
                )}
            </>
        );
    };

    const getRandomShape = () => {
        // Define a list of shape classes
        // const shapes = ["circle", "square", "triangle", "star"];
        const shapes = ["circle", "triangle", "star", "square"];

        // Randomly pick one of the shapes
        const randomIndex = Math.floor(Math.random() * shapes.length);
        return shapes[randomIndex];
    };
    const getRandomColor = () => {
        // Randomly generate a color using RGB values
        const r = Math.floor(Math.random() * 256);
        const g = Math.floor(Math.random() * 256);
        const b = Math.floor(Math.random() * 256);
        return `rgb(${r}, ${g}, ${b})`;
    };

    const providerColorMap = {};

    const getProviderColor = (provider) => {
        if (!provider) return "rgba(125, 161, 235, 1)";

        // If this provider doesn't have a color yet, assign one randomly
        if (!providerColorMap[provider]) {
            providerColorMap[provider] = getRandomColor();
        }

        return providerColorMap[provider];
    };

    const providerShapeMap = {};

    const getProvidershape = (provider) => {
        if (!provider) return "square";

        // If this provider doesn't have a color yet, assign one randomly
        if (!providerShapeMap[provider]) {
            providerShapeMap[provider] = getRandomShape();
        }

        return providerShapeMap[provider];
    };


    const handletimelinedatalist = async () => {

        try {
            setloading(true);
            const caseID = localStorage.getItem("caseID");
            const filter_timeline_report = localStorage.getItem("filter_timeline_report");
            const payload = {
                case_id: caseID,
            };

            if (filter_timeline_report) {
                try {
                    const parsed = JSON.parse(filter_timeline_report);
                    let pages;

                    if (Array.isArray(parsed)) {

                        if (typeof parsed[0] === "string") {
                            pages = parsed[0].split(",").map(Number);
                        } else {
                            pages = parsed.map(Number);
                        }
                    } else if (typeof parsed === "string" || typeof parsed === "number") {

                        pages = [Number(parsed)];
                    } else {
                        pages = [];
                    }
                    payload.search_keyword_page_no = pages;
                    payload.mode = "report_search_keyword";
                } catch {
                    payload.search_keyword_page_no = filter_timeline_report.split(",").map(Number);
                    payload.mode = "report_search_keyword";
                }
            } else {
                payload.mode = "list_events";
            }

            const response = await axios.post(`${API_BASE_URL}timeline`, payload);

            if (response.data.status === 1) {
                const timelinedata = response.data.message;
                const reportcaseName = timelinedata.caseTitle || "Unknown";
                const minTimestamp = moment(timelinedata.beforeOneMonth, "MM/DD/YYYY").valueOf();
                const maxTimestamp = moment(timelinedata.afterOneMonth, "MM/DD/YYYY").valueOf();
                const defaulttimestampstart = moment(timelinedata.focusDate, "MM/DD/YYYY").valueOf();
                const defaultEndTimestamp = moment(timelinedata.focusDate, "MM/DD/YYYY").add(1, "months").valueOf();
                setVisibleTimeStart(defaulttimestampstart);
                setVisibleTimeEnd(defaultEndTimestamp);
                setminTime(minTimestamp);
                setmaxTime(maxTimestamp);
                setdefaultTimeStart(defaulttimestampstart);
                setdefaultTimeEnd(defaultEndTimestamp);
                setCaseName(reportcaseName);

                const processedItems = timelinedata.timeline.map((item, i) => {
                    const start = moment(item.caseFactDate, "MM/DD/YYYY").startOf("day").valueOf();

                    // const end = moment(start).add(1 + Math.floor(Math.random() * 0.5), "hours").valueOf();
                    const end = moment(start).add(5, "minutes").valueOf();

                    // const titleLength = item.caseFactTitle?.length || 10; // fallback to 10 chars
                    // const extraTime = (titleLength * 6) / pixelsPerMs; // 6px per char
                    // const end = start + extraTime;
                    const id = item.caseFactId;
                    let randomSeed = Math.floor(Math.random() * 1000);
                    const shape = getProvidershape(item.caseFactProvider);
                    const shapeColor = getProviderColor(item.caseFactProvider);
                    return {
                        ...item,
                        start,
                        end,
                        id,
                        shape,
                        shapeColor,
                        canMove: false,
                        canResize: false,
                        bgColor: randomColor({
                            luminosity: "light",
                            seed: randomSeed + i,
                            format: "rgba",
                            alpha: 0.6,
                        }),
                        selectedBgColor: randomColor({
                            luminosity: "light",
                            seed: randomSeed + i,
                            format: "rgba",
                            alpha: 1,
                        }),
                        color: randomColor({ luminosity: "dark", seed: randomSeed + i }),
                    };
                });
                const adjustitems = adjustItemsToAvoidOverlap(processedItems);
                setbaseItems(adjustitems);
                setogbaseItems(adjustitems);
                setloading(false);
                setfileUrl(timelinedata.pdfUrl);
            }

        } catch (error) {
            console.error("Error fetching tags:", error);
            setloading(false);
        }
    };

    useEffect(() => {
        // Initial fetch
        handletimelinedatalist();

        const handleStorageChange = (event) => {
            if (event.key === "caseID") {
                handletimelinedatalist();
            }
        };

        window.addEventListener("storage", handleStorageChange);

        return () => {
            window.removeEventListener("storage", handleStorageChange);
        };
    }, []);

    const handleFilterSearch = async () => {
        if (!searchTerm.trim()) {
            // Empty search = reset to original
            setbaseItems(ogbaseItems);
            return;
        }

        setsearchstate(true);
        setloading(true);
        // setItems([]);
        try {
            const caseID = localStorage.getItem("caseID");
            const filter_timeline_report = localStorage.getItem("filter_timeline_report");

            const payload = {
                case_id: caseID,
                keyword: searchTerm
            };

            if (filter_timeline_report) {
                try {
                    const parsed = JSON.parse(filter_timeline_report); // e.g. ["1,2,3,4,5"]
                    let pages;

                    if (Array.isArray(parsed)) {

                        if (typeof parsed[0] === "string") {
                            pages = parsed[0].split(",").map(Number);
                        } else {
                            pages = parsed.map(Number);
                        }
                    } else if (typeof parsed === "string" || typeof parsed === "number") {

                        pages = [Number(parsed)];
                    } else {
                        pages = [];
                    }
                    payload.search_keyword_page_no = pages;
                    payload.mode = "global_keyword_search";
                } catch {
                    payload.search_keyword_page_no = filter_timeline_report.split(",").map(Number);
                    payload.mode = "global_keyword_search";
                }
            } else {
                payload.mode = "global_keyword_search";
            }

            const response = await axios.post(`${API_BASE_URL}timeline`, payload);

            if (response.data.status === 1) {
                const timelinedata = response.data.message;
                const reportcaseName = timelinedata.caseTitle || "Unknown";
                const minTimestamp = moment(timelinedata.beforeOneMonth, "MM/DD/YYYY").valueOf();
                const maxTimestamp = moment(timelinedata.afterOneMonth, "MM/DD/YYYY").valueOf();
                const defaulttimestampstart = moment(timelinedata.focusDate, "MM/DD/YYYY").valueOf();
                const defaultEndTimestamp = moment(timelinedata.focusDate, "MM/DD/YYYY").add(1, "months").valueOf();
                setVisibleTimeStart(defaulttimestampstart);
                setVisibleTimeEnd(defaultEndTimestamp);
                setminTime(minTimestamp);
                setmaxTime(maxTimestamp);
                setdefaultTimeStart(defaulttimestampstart);
                setdefaultTimeEnd(defaultEndTimestamp);
                setCaseName(reportcaseName);

                const processedItems = timelinedata.timeline.map((item, i) => {
                    const start = moment(item.caseFactDate, "MM/DD/YYYY").startOf("day").valueOf();

                    const end = moment(start).add(1 + Math.floor(Math.random() * 4), "hours").valueOf();

                    // const titleLength = item.caseFactTitle?.length || 10; // fallback to 10 chars
                    // const extraTime = (titleLength * 6) / pixelsPerMs; // 6px per char
                    // const end = start + extraTime;
                    const id = item.caseFactId;
                    let randomSeed = Math.floor(Math.random() * 1000);
                    const shape = getRandomShape();
                    const shapeColor = getRandomColor();
                    return {
                        ...item,
                        start,
                        end,
                        id,
                        shape,
                        shapeColor,
                        canMove: false,
                        canResize: false,
                        bgColor: randomColor({
                            luminosity: "light",
                            seed: randomSeed + i,
                            format: "rgba",
                            alpha: 0.6,
                        }),
                        selectedBgColor: randomColor({
                            luminosity: "light",
                            seed: randomSeed + i,
                            format: "rgba",
                            alpha: 1,
                        }),
                        color: randomColor({ luminosity: "dark", seed: randomSeed + i }),
                    };
                });
                setbaseItems(processedItems);
                setogbaseItems(processedItems);
                setloading(false);
            }
        } catch (error) {
            console.error("Error fetching tags:", error);
            setloading(false);
        }

    };


    const timelineWrapperRef = useRef(null);

    useEffect(() => {
        const timelineContainer = timelineWrapperRef.current;
        if (!timelineContainer) return;

        const handleWheel = (e) => {
            e.preventDefault();
            if (e.deltaY < 0) handleZoom(true); // zoom in
            else handleZoom(false); // zoom out
        };

        timelineContainer.addEventListener("wheel", handleWheel, { passive: false });
        return () => {
            timelineContainer.removeEventListener("wheel", handleWheel);
        };
    }, [visibleTimeStart, visibleTimeEnd]);


    // --- Center line calculation based on timeline time scale ---
    const centerTime = (visibleTimeStart + visibleTimeEnd) / 2;
    const timelineWidth = timelineRef.current?.container?.clientWidth || window.innerWidth;
    const pixelsPerMs = timelineWidth / (visibleTimeEnd - visibleTimeStart);
    const centerX = (centerTime - visibleTimeStart) * pixelsPerMs;



    // --- calculate zoom limits ---
    const minRange = 1 * 60 * 60 * 1000; // 1 day
    const maxRange = maxTime - minTime;

    const canZoomIn = visibleTimeEnd && visibleTimeStart && (visibleTimeEnd - visibleTimeStart) > minRange;
    const canZoomOut = visibleTimeEnd && visibleTimeStart && (visibleTimeEnd - visibleTimeStart) < maxRange;
    const zoomFrame = useRef(null);
    const handleZoom = (zoomIn) => {
        if (!canZoomIn && zoomIn) return;
        if (!canZoomOut && !zoomIn) return;

        const zoomFactor = 0.2;
        const range = visibleTimeEnd - visibleTimeStart;
        const center = (visibleTimeStart + visibleTimeEnd) / 2;

        let newRange = zoomIn ? range * (1 - zoomFactor) : range * (1 + zoomFactor);
        newRange = Math.max(minRange, Math.min(newRange, maxRange));

        let newStart = center - newRange / 2;
        let newEnd = center + newRange / 2;

        if (newStart < minTime) {
            newStart = minTime;
            newEnd = minTime + newRange;
        }
        if (newEnd > maxTime) {
            newEnd = maxTime;
            newStart = maxTime - newRange;
        }

        const value = Math.min(
            100,
            Math.max(
                0,
                100 - ((newEnd - newStart) / (maxTime - minTime)) * 100
            )
        );
        setSliderValue(value);

        // setVisibleTimeStart(newStart);
        // setVisibleTimeEnd(newEnd);
        if (!zoomFrame.current) {
            zoomFrame.current = requestAnimationFrame(() => {
                setVisibleTimeStart(newStart);
                setVisibleTimeEnd(newEnd);
                const value = Math.min(100, Math.max(0, 100 - ((newEnd - newStart) / (maxTime - minTime)) * 100));
                setSliderValue(value);
                zoomFrame.current = null;
            });
        }
    };


    // console.log("visibleTimeStart", moment(visibleTimeStart).format("MMM D, YYYY"));
    // console.log("visibleTimeEnd", moment(visibleTimeEnd).format("MMM D, YYYY"));
    // console.log("defaultTimeStart", moment(defaultTimeStart).format("MMM D, YYYY"));
    // console.log("defaultTimeEnd", moment(defaultTimeEnd).format("MMM D, YYYY"));
    // console.log("defaultTimeEnd", moment(minTime).format("MMM D, YYYY"));
    // console.log("defaultTimeEnd", moment(maxTime).format("MMM D, YYYY"));
    const handleCloseSelectedItemModal = (isedited) => {
        setSelectedItem(null);
        if (isedited) {
            handletimelinedatalist();
        }
    };

    const handleLogOut = () => {
        localStorage.clear();
        localStorage.setItem("attesta_timeline_logout", Date.now());
        navigate("/");
    };


    useEffect(() => {
        const handleStorageChange = (event) => {

            if (event.key === "caseID" || "filter_timeline_report") {
                window.close();
            }
            // Handle any other case like logging out
            if (event.key === "attesta_timeline_logout") {
                localStorage.clear();
                navigate("/"); // Redirect to login/home
            }
        };
        window.addEventListener("storage", handleStorageChange);
        return () => {
            window.removeEventListener("storage", handleStorageChange);
        };
    }, [navigate]);


    //filter functionality start
    //   Filters popup functions //add -start
    const toggleProviderPopUp = () => {
        // console.log('first');
        setProviderPopupOpen((prev) => {
            if (!prev) {
                setDatePopupOpen(false);
                setStatusPopupOpen(false);
                setSearchPopupOpen(false);
            } // close other
            return !prev;
        });
    };

    const toggleStatusPopUp = () => {
        // console.log('second');
        setStatusPopupOpen((prev) => {
            if (!prev) {
                setProviderPopupOpen(false);
                setDatePopupOpen(false);
                setSearchPopupOpen(false);
            } // close other
            return !prev;
        });
    };
    const toggleDatePopUp = () => {
        setDatePopupOpen((prev) => {
            if (!prev) {
                setProviderPopupOpen(false);
                setStatusPopupOpen(false);
                setSearchPopupOpen(false);
            }
            return !prev;
        });
    };

    const toggleSearchPopUp = () => {
        setSearchPopupOpen((prev) => {
            if (!prev) {
                setProviderPopupOpen(false);
                setStatusPopupOpen(false);
                setDatePopupOpen(false);
            }
            return !prev;
        });
    };

    const clearSearch = () => {
        setSearchKeywords('');
        // Re-apply filters without search
        setSearchFilters({
            title: true,
            provider: false,
            organization: false,
        });
        setbaseItems(
            filterItems(
                selectedProviders,
                visibilityFilter,
                startDateFilter,
                endDateFilter,
            ),
        );
    };

    const handleSearchGo = () => {
        const noFiltersSelected = !searchfilters.title && !searchfilters.provider && !searchfilters.organization;

        if (searchKeywords.trim() === '' || noFiltersSelected) {
            return;
        }
        const keywords = searchKeywords
            .split(',')
            .map((kw) => kw.trim().toLowerCase())
            .filter(Boolean);

        const providers =
            selectedProviders.length > 0
                ? selectedProviders
                : [...new Set(ogbaseItems.map((item) => item.caseFactProvider))];

        const result = ogbaseItems.filter((item) => {
            const matchesProvider = providers.includes(item.caseFactProvider);

            const matchesVisibility =
                visibilityFilter === 'all' ||
                (visibilityFilter === 'hidden' && item.caseFactIsHide === 1) ||
                (visibilityFilter === 'visible' && item.caseFactIsHide === 0);

            const itemDate = new Date(item.caseFactDate);
            const startMatch = startDateFilter
                ? itemDate >= new Date(startDateFilter)
                : true;
            const endMatch = endDateFilter
                ? itemDate <= new Date(endDateFilter)
                : true;

            // Filters by check buttons
            const activeFields = [];
            if (searchfilters.title) activeFields.push(item.caseFactTitle);
            if (searchfilters.provider) activeFields.push(item.caseFactProvider);
            if (searchfilters.organization) activeFields.push(item.caseFactOrg);

            const matchesSearch =
                keywords.length === 0 ||
                activeFields.some(
                    (field) =>
                        field &&
                        keywords.some((keyword) => field.toLowerCase().includes(keyword)),
                );

            return (
                matchesProvider &&
                matchesVisibility &&
                startMatch &&
                endMatch &&
                matchesSearch
            );
        });
        if (result.length > 0) {
            const firstItemStart = result[0].start;

            // One week before and after
            const defaulttimestampstart = moment(firstItemStart).subtract(1, "weeks").valueOf();
            const defaultEndTimestamp = moment(firstItemStart).add(1, "weeks").valueOf();

            setVisibleTimeStart(defaulttimestampstart);
            setVisibleTimeEnd(defaultEndTimestamp);
        }
        setbaseItems(result);
    };

    const filterItems = (providers, visibility, startDate, endDate) => {
        return ogbaseItems.filter((item) => {
            const matchesProvider = providers.includes(item.caseFactProvider);
            const matchesVisibility =
                visibility === 'all' ||
                (visibility === 'hidden' && item.caseFactIsHide === 0) ||
                (visibility === 'visible' && item.caseFactIsHide === 1);

            const itemDate = new Date(item.caseFactDate);

            const startMatch = startDate ? itemDate >= new Date(startDate) : true;

            const endMatch = endDate ? itemDate <= new Date(endDate) : true;

            return matchesProvider && matchesVisibility && startMatch && endMatch;
        });
    };

    const handleVisibilityChange = (e) => {
        const newVisibility = e.target.value;
        console.log(newVisibility)
        setVisibilityFilter(newVisibility);
        let filteritems = filterItems(
            selectedProviders,
            newVisibility,
            startDateFilter,
            endDateFilter,
        );
        if (newVisibility !== "hidden") {
            setVisibleTimeStart(defaultTimeStart);
            setVisibleTimeEnd(defaultTimeEnd);
        } else if (filteritems.length > 0) {
            const firstItemStart = filteritems[0].start;

            // One week before and after
            const defaulttimestampstart = moment(firstItemStart).subtract(1, "weeks").valueOf();
            const defaultEndTimestamp = moment(firstItemStart).add(1, "weeks").valueOf();

            setVisibleTimeStart(defaulttimestampstart);
            setVisibleTimeEnd(defaultEndTimestamp);
        }
        setbaseItems(filteritems);
    };

    const handleStartDateChange = (e) => {
        const value = e.target.value;
        setStartDateFilter(value);
        // setfilteredItems(
        //   filterItems(selectedProviders, visibilityFilter, value, endDateFilter),
        // );
    };

    const handleEndDateChange = (e) => {
        const value = e.target.value;
        setEndDateFilter(value);
        // setfilteredItems(
        //   filterItems(selectedProviders, visibilityFilter, startDateFilter, value),
        // );
    };

    const handleFilterDateGo = () => {
        if (startDateFilter === "" || endDateFilter === "") return;
        let filteritems = filterItems(
            selectedProviders,
            visibilityFilter,
            startDateFilter,
            endDateFilter,
        );
        if (filteritems.length > 0) {
            const firstItemStart = filteritems[0].start;

            // One week before and after
            const defaulttimestampstart = moment(firstItemStart).subtract(1, "weeks").valueOf();
            const defaultEndTimestamp = moment(firstItemStart).add(1, "weeks").valueOf();

            setVisibleTimeStart(defaulttimestampstart);
            setVisibleTimeEnd(defaultEndTimestamp);
        }
        setbaseItems(
            filteritems
        );
    };

    const handleProviderChange = (provider) => {
        setSelectedProviders((prev) => {
            const updated = prev.includes(provider)
                ? prev.filter((p) => p !== provider)
                : [...prev, provider];
            let filteritems = filterItems(
                updated, visibilityFilter, startDateFilter, endDateFilter
            );
            setbaseItems(filteritems);

            if (filteritems.length > 0) {
                const firstItemStart = filteritems[0].start;

                // One week before and after
                const defaulttimestampstart = moment(firstItemStart).subtract(1, "weeks").valueOf();
                const defaultEndTimestamp = moment(firstItemStart).add(1, "weeks").valueOf();

                setVisibleTimeStart(defaulttimestampstart);
                setVisibleTimeEnd(defaultEndTimestamp);
            }
            return updated;
        });
    };

    const clearDateFilters = () => {
        if (startDateFilter === "" || endDateFilter === "") return;
        setStartDateFilter('');
        setEndDateFilter('');

        // Re-apply filters without date limits
        const providers =
            selectedProviders.length > 0
                ? selectedProviders
                : [...new Set(ogbaseItems.map((item) => item.caseFactProvider))];

        const result = ogbaseItems.filter((item) => {
            const matchesProvider = providers.includes(item.caseFactProvider);
            const matchesVisibility =
                visibilityFilter === 'all' ||
                (visibilityFilter === 'hidden' && item.caseFactIsHide === 1) ||
                (visibilityFilter === 'visible' && item.caseFactIsHide === 0);

            // Don't apply date filtering here (because we are clearing it)
            return matchesProvider && matchesVisibility;
        });

        setbaseItems(result);
        setVisibleTimeStart(defaultTimeStart);
        setVisibleTimeEnd(defaultTimeEnd);
    };

    useEffect(() => {
        const currentProviders = [
            ...new Set(ogbaseItems.map((item) => item.caseFactProvider)),
        ];

        const areArraysEqual = (a, b) =>
            a.length === b.length && a.every((value) => b.includes(value));

        if (!areArraysEqual(prevProvidersRef.current, currentProviders)) {
            setSelectedProviders(currentProviders);
            setbaseItems(ogbaseItems);
            prevProvidersRef.current = currentProviders;
        }
    }, [ogbaseItems]);
    //filter functionality end





    //fast backward & forward start
    const handleFastBackward = () => {
        if (items.length === 0) return; // Guard clause in case items are empty

        // Find the minimum start date from items using moment
        const minStartDate = moment.min(items.map(item => moment(item.start))).valueOf();

        // Subtract one week (7 days) from the minimum start date
        const defaultTimestampStart = moment(minStartDate).subtract(1, 'weeks').valueOf();
        const defaultEndTimestamp = moment(minStartDate).add(1, 'weeks').valueOf();

        // Update the visible time range
        setVisibleTimeStart(defaultTimestampStart);
        setVisibleTimeEnd(defaultEndTimestamp);
    };

    const handleFastForward = () => {
        if (items.length === 0) return; // Guard clause in case items are empty

        // Find the minimum start date from items using moment
        const minStartDate = moment.max(items.map(item => moment(item.start))).valueOf(); // Get the earliest startDate

        // Add one week (7 days) to the minimum start date
        const defaultTimestampStart = moment(minStartDate).subtract(1, 'weeks').valueOf();
        const defaultEndTimestamp = moment(minStartDate).add(1, 'weeks').valueOf();

        // Update the visible time range
        setVisibleTimeStart(defaultTimestampStart);
        setVisibleTimeEnd(defaultEndTimestamp);
    };


    useEffect(() => {
        let cancelled = false;
        const loadPdf = async () => {
            if (!fileUrl) return;
            const loadingTask = pdfjsLib.getDocument({
                url: fileUrl,
                withCredentials: false,
            });
            const loadedPdf = await loadingTask.promise;
            if (!cancelled) setPdf(loadedPdf);
        };

        loadPdf();
        return () => {
            cancelled = true;
        };
    }, [fileUrl]);

    const [isverticaltimeopen, setisverticalTimelineopen] = useState(false);


    const handleCloseSverticaltimelineModal = () => {
        setisverticalTimelineopen(false)
    };


    return (
        <div className="welcome-page">
            {isloading && (
                <Loader size={100} />
            )}
            {isverticaltimeopen && (<VerticalTimeline caseName={caseName} handleCloseSverticaltimelineModal={handleCloseSverticaltimelineModal} isverticaltimeopen={isverticaltimeopen} />
            )}
            <div className="topbar d-print-none">
                <div className="timeline-padding timeline-wrapper">
                    <div className="main-wrapper">
                        <div style={{ position: "relative", height: "100vh", width: "100%" }} ref={OveralltimelineRef} >
                            <div className="tlm-header">
                                <div className="tlm-header-left gap-5">
                                    <div className="tlm-header-title">
                                        File Name: <span className="tls-meta-highlight">{caseName}</span>
                                    </div>
                                </div>
                                <div className="tlm-header-right flex-wrap">
                                    <div className="d-flex gap-1">  <input
                                        type="text"
                                        placeholder="Global Search..."
                                        className="tlm-header-search"
                                        value={searchTerm}
                                        onChange={(e) => setSearchTerm(e.target.value)}
                                    />

                                        <button className="tlm-header-btn" onClick={handleFilterSearch}>Search</button>
                                        {searchstate && (
                                            <button
                                                className="tlm-header-btn"
                                                onClick={() => {
                                                    setSearchTerm("");
                                                    // setItems([]);
                                                    handletimelinedatalist();
                                                    setsearchstate(false);
                                                }}
                                            >
                                                Reset
                                            </button>
                                        )}</div>
                                    {/* <div className="border-line"></div>
                                    <button className="tlm-header-btn caselist" onClick={() => navigate("/welcome")}>Case List</button> */}
                                    {/* <button className="tlm-header-btn" onClick={handleLogOut}>Logout</button> */}
                                </div>

                            </div>
                            <div style={{ height: "30px" }} />
                            <div
                                ref={headerRef}
                                style={{
                                    position: "absolute",
                                    bottom: 30,
                                    left: 0,
                                    right: 0,
                                    height: 62,
                                    cursor: "grab",
                                    zIndex: 20,
                                }}
                            />
                            <div style={{ position: "relative", height: "calc(100vh  - 60px)", width: "100%" }} ref={timelineWrapperRef}>

                                <Timeline
                                    ref={timelineRef}
                                    groups={groups}

                                    items={items.filter(
                                        (item) =>
                                            item.end > (visibleTimeStart ?? minTime) &&
                                            item.start < (visibleTimeEnd ?? moment(minTime).add(7, "days").valueOf())
                                    )}
                                    // items={items}
                                    keys={keys}
                                    itemTouchSendsClick={false}
                                    stackItems={false}
                                    itemHeightRatio={0.75}
                                    lineHeight={40}
                                    showCursorLine
                                    canMove={false}
                                    canResize={false}
                                    visibleTimeStart={visibleTimeStart || minTime}
                                    visibleTimeEnd={visibleTimeEnd || moment(minTime).add(7, "days").valueOf()}
                                    defaultTimeStart={defaultTimeStart}
                                    defaultTimeEnd={defaultTimeEnd}

                                    minTime={visibleTimeStart}
                                    maxTime={visibleTimeEnd}
                                    minZoom={1 * 60 * 60 * 1000}
                                    maxZoom={(maxTime - minTime)}
                                    // itemRenderer={itemRenderer}
                                    itemRenderer={(props) => itemRenderer({ ...props, selectedItem })}

                                    timeSteps={{
                                        second: 1,
                                        minute: 1,
                                        hour: 1,
                                        day: 1,
                                        month: 1,
                                        year: 1,
                                    }}
                                    onTimeChange={(start, end, updateScrollCanvas) => {
                                        setVisibleTimeStart(start);
                                        setVisibleTimeEnd(end);
                                    }}
                                    onCanvasClick={() => { }}
                                    style={{
                                        height: "100%",
                                        width: "100%",
                                        display: "flex",
                                        flexDirection: "column-reverse",
                                    }}
                                >
                                    <TimelineHeaders>
                                        <DateHeader unit="primaryHeader" />
                                        <DateHeader
                                            intervalRenderer={({ getIntervalProps, intervalContext }) => {
                                                const { interval, intervalText } = intervalContext;
                                                const m = moment(interval.startTime);

                                                let label = intervalText;
                                                let fontSize = "10px";
                                                console.log(label, interval)
                                                if (m.isValid()) {
                                                    // Match format like: Friday, August 18, 2023
                                                    // const longFormatRegex = /^[A-Za-z]+, [A-Za-z]+ \d{1,2}, \d{4}$/;

                                                    // if (longFormatRegex.test(intervalText)) {
                                                    //     // Change only this format → convert to MM/DD
                                                    //     // label = m.format("MM/DD");
                                                    //     const m = moment(intervalText, "dddd, MMMM D, YYYY");

                                                    //     // Format to "Sat, Aug 19, 2023"
                                                    //     label = m.format("MMM D, YYYY");
                                                    //     fontSize = "8px";

                                                    // }
                                                    const timeFormatRegex = /^\d{2}\/\d{2}\/\d{4}, \d{2}:\d{2}$/;
                                                    const dateTimeFormatRegex = /^[A-Za-z]+, [A-Za-z]+ \d{1,2}, \d{4}, \d{2}:\d{2}$/;
                                                    const longFormatRegex = /^[A-Za-z]+, [A-Za-z]+ \d{1,2}, \d{4}$/;

                                                    if (timeFormatRegex.test(intervalText)) {
                                                        // Format like "08/26/2023, 01:00"
                                                        const time = moment(intervalText, "MM/DD/YYYY, HH:mm").format("HH:mm");
                                                        label = time; // Only show time
                                                    } else if (dateTimeFormatRegex.test(intervalText)) {
                                                        // Format like "Saturday, August 26, 2023, 07:00"
                                                        const time = moment(intervalText, "dddd, MMMM D, YYYY, HH:mm").format("HH:mm");
                                                        label = time; // Only show time
                                                    } else if (longFormatRegex.test(intervalText)) {
                                                        // Format like "Saturday, August 19, 2023"
                                                        const m = moment(intervalText, "dddd, MMMM D, YYYY");
                                                        label = m.format("MMM D, YYYY"); // Format date as "Sat, Aug 19, 2023"
                                                    }
                                                }
                                                return (
                                                    <div {...getIntervalProps()} className="rct-dateHeader" >
                                                        {label}
                                                    </div>
                                                );
                                            }}
                                        />
                                    </TimelineHeaders>
                                </Timeline>
                                {/* Center line */}
                                {!isloading && (

                                    <div
                                        style={{
                                            position: "absolute",
                                            top: 0,
                                            bottom: 30,
                                            left: centerX,
                                            width: "0px",
                                            borderLeft: "2px dotted black",
                                            zIndex: 10,
                                            pointerEvents: "none",
                                        }}
                                    />
                                )}

                                {/* <div
                                    style={{
                                        position: "absolute",
                                        top: 10,
                                        left: centerX,
                                        transform: "translateX(-50%)",
                                        background: "#333",
                                        color: "#fff",
                                        padding: "4px 10px",
                                        borderRadius: "4px",
                                        fontSize: "14px",
                                        fontWeight: "bold",
                                        zIndex: 999,
                                    }}
                                >
                                    {moment(centerTime).format("MMM DD, YYYY")}
                                </div> */}
                                {/* Zoom/Pan Controls */}
                                <div
                                    className="no-print"
                                    style={{
                                        position: "absolute",
                                        top: "50%",
                                        right: 10,
                                        transform: "translateY(-50%)",
                                        background: "#f0f0f0",
                                        padding: "12px 5px",
                                        borderRadius: "12px",
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        gap: "5px",
                                        color: "#a5c94c",
                                        width: "60px",
                                        zIndex: 100,
                                    }}
                                >
                                    <button
                                        onClick={() => handleZoom(true)}
                                        disabled={!canZoomIn}
                                        style={{ background: "none", border: "none", fontSize: "16px", lineHeight: '1' }}
                                    >
                                        <i class="fa-solid fa-plus"></i>
                                    </button>

                                    <input
                                        type="range"
                                        min="1"
                                        max="100"
                                        value={sliderValue}
                                        onChange={handleSliderChange}
                                        onMouseUp={() => handleSliderCommit(sliderValue)}   // smooth: commit on release
                                        onTouchEnd={() => handleSliderCommit(sliderValue)} // for mobile
                                        className="file-view-range"
                                        style={{
                                            writingMode: "bt-lr",
                                            transform: "rotate(-90deg)",
                                            height: "150px",
                                            transformOrigin: "center",
                                            cursor: "pointer"

                                        }}
                                    />

                                    <button
                                        onClick={() => handleZoom(false)}
                                        disabled={!canZoomOut}
                                        style={{ background: "none", border: "none", fontSize: "16px", lineHeight: '1' }}
                                    >
                                        <i class="fa-solid fa-minus"></i>
                                    </button>

                                    {/* <div style={{ display: "flex", gap: "1px", marginTop: "8px" }}>
                                        <button
                                            onClick={() => {
                                                const shift = (visibleTimeEnd - visibleTimeStart) * 0.2;
                                                setVisibleTimeStart(
                                                    Math.max(minTime, visibleTimeStart - shift)
                                                );
                                                setVisibleTimeEnd(
                                                    Math.max(
                                                        minTime + (visibleTimeEnd - visibleTimeStart),
                                                        visibleTimeEnd - shift
                                                    )
                                                );
                                            }}
                                            style={{ background: "none", border: "none", fontSize: "20px" }}
                                        >
                                            ◀
                                        </button>
                                        <button
                                            onClick={() => {
                                                const shift = (visibleTimeEnd - visibleTimeStart) * 0.2;
                                                setVisibleTimeStart(
                                                    Math.min(
                                                        maxTime - (visibleTimeEnd - visibleTimeStart),
                                                        visibleTimeStart + shift
                                                    )
                                                );
                                                setVisibleTimeEnd(Math.min(maxTime, visibleTimeEnd + shift));
                                            }}
                                            style={{ background: "none", border: "none", fontSize: "20px" }}
                                        >
                                            ▶
                                        </button>
                                    </div> */}


                                    <div style={{ display: "flex", gap: "1px", marginTop: "8px" }}>
                                        <button
                                            onClick={() => {
                                                const shift = (visibleTimeEnd - visibleTimeStart) * 0.2;
                                                setVisibleTimeStart(
                                                    Math.max(minTime, visibleTimeStart - shift)
                                                );
                                                setVisibleTimeEnd(
                                                    Math.max(
                                                        minTime + (visibleTimeEnd - visibleTimeStart),
                                                        visibleTimeEnd - shift
                                                    )
                                                );
                                            }}
                                            style={{ background: "none", border: "none", fontSize: "14px", padding: '0px 4px' }}
                                        >
                                            <i class="fa-solid fa-angle-left"></i>
                                        </button>
                                        <button
                                            onClick={() => {
                                                const shift = (visibleTimeEnd - visibleTimeStart) * 0.2;
                                                setVisibleTimeStart(
                                                    Math.min(
                                                        maxTime - (visibleTimeEnd - visibleTimeStart),
                                                        visibleTimeStart + shift
                                                    )
                                                );
                                                setVisibleTimeEnd(Math.min(maxTime, visibleTimeEnd + shift));
                                            }}
                                            style={{ background: "none", border: "none", fontSize: "14px", padding: '0px 4px' }}
                                        >
                                            <i class="fa-solid fa-angle-right"></i>
                                        </button>
                                    </div>
                                    <div style={{ display: "flex", gap: "1px", marginTop: "8px" }}>
                                        <button
                                            onClick={handleFastBackward}
                                            style={{ background: "none", border: "none", fontSize: "14px", padding: '0px 4px' }}
                                        >
                                            <i class="fa-solid fa-angles-left"></i>
                                        </button>
                                        <button
                                            onClick={handleFastForward}
                                            style={{ background: "none", border: "none", fontSize: "14px", padding: '0px 4px' }}
                                        >
                                            <i class="fa-solid fa-angles-right"></i>
                                        </button>
                                    </div>



                                </div>

                            </div>

                            <div
                            // style={{
                            //     height: "100vh",
                            //     display: "flex",
                            //     justifyContent: "center",
                            //     alignItems: "center",
                            // }}
                            >

                            </div>
                            {/* Filters and popup */}
                            <div className="timeline-filter-bar">
                                <div className="p-1" style={{ position: 'relative' }}>
                                    <PiTreeViewFill
                                        className="filter-icons"
                                        title="Vertical Timeline"
                                        size={18}
                                        onClick={() => setisverticalTimelineopen(true)}
                                    />
                                </div>
                                <div className="p-1" style={{ position: 'relative' }}>
                                    <IoMdPrint
                                        className="filter-icons"
                                        title="Print"
                                        size={18}
                                        onClick={handlePreview}
                                    />
                                </div>
                                <div className="p-1" style={{ position: 'relative' }}>
                                    <RiTimelineView
                                        className="filter-icons"
                                        title="Filter by Provider"
                                        size={18}
                                        onClick={toggleProviderPopUp}
                                    />
                                    {isProviderPopupOpen && (
                                        <div className="filter-pop-wrapper">
                                            {/* Header and Close */}
                                            <div>
                                                <div
                                                    className="cls-btn"
                                                    onClick={() => setProviderPopupOpen(false)}
                                                >
                                                    <i class="fa-solid fa-xmark"></i>
                                                </div>

                                                <span className="timeline-filter-title">
                                                    Provider Filter
                                                </span>
                                            </div>

                                            {/* Provider Checkboxes */}
                                            <div className="tree-filter-box"
                                                style={{
                                                    height: '170px',
                                                    overflowY: 'auto',
                                                    marginBottom: '6px',
                                                    paddingBottom: '6px',
                                                    paddingRight: '8px',
                                                }}
                                            >
                                                {[
                                                    ...new Set(
                                                        ogbaseItems.map((item) => item.caseFactProvider),
                                                    ),
                                                ].map((provider) => (
                                                    <label
                                                        key={provider}
                                                    >
                                                        <input
                                                            type="checkbox"
                                                            checked={selectedProviders.includes(provider)}
                                                            onChange={() => handleProviderChange(provider)}
                                                            style={{ marginRight: '8px' }}
                                                        />
                                                        <span>{provider}</span>
                                                    </label>
                                                ))}
                                            </div>

                                            {/* Check All Toggle */}
                                            <label
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    fontSize: '13px',
                                                    color: "#2a2a2a",
                                                    cursor: 'pointer',
                                                    borderTop: '1px solid #e2e2e2',
                                                    paddingTop: '6px',
                                                }}
                                            >
                                                <input
                                                    type="checkbox"
                                                    checked={
                                                        selectedProviders.length ===
                                                        [
                                                            ...new Set(
                                                                ogbaseItems.map(
                                                                    (item) => item.caseFactProvider,
                                                                ),
                                                            ),
                                                        ].length
                                                    }
                                                    onChange={(e) => {
                                                        if (e.target.checked) {
                                                            setSelectedProviders([
                                                                ...new Set(
                                                                    ogbaseItems.map(
                                                                        (item) => item.caseFactProvider,
                                                                    ),
                                                                ),
                                                            ]);
                                                            if (ogbaseItems.length > 0) {
                                                                const firstItemStart = ogbaseItems[0].start;

                                                                // One week before and after
                                                                const defaulttimestampstart = moment(firstItemStart).subtract(1, "weeks").valueOf();
                                                                const defaultEndTimestamp = moment(firstItemStart).add(1, "weeks").valueOf();

                                                                setVisibleTimeStart(defaultTimeStart);
                                                                setVisibleTimeEnd(defaultTimeEnd);
                                                            }
                                                            setbaseItems(ogbaseItems);
                                                        } else {
                                                            setSelectedProviders([]);
                                                            setbaseItems([]);
                                                        }
                                                    }}
                                                    style={{ marginRight: '8px' }}
                                                />
                                                Check All / Uncheck All
                                            </label>

                                            {/* Arrow */}
                                            <div
                                                style={{
                                                    position: 'absolute',
                                                    bottom: '-10px',
                                                    right: '10px',
                                                    width: 0,
                                                    height: 0,
                                                    borderLeft: '8px solid transparent',
                                                    borderRight: '8px solid transparent',
                                                    borderTop: '10px solid #fff',
                                                }}
                                            />
                                        </div>
                                    )}
                                </div>

                                <div className="p-1" style={{ position: 'relative' }}>
                                    <BsFillPersonCheckFill
                                        className="filter-icons"
                                        title="Filter by Status"
                                        size={18}
                                        onClick={toggleStatusPopUp}
                                    />
                                    {isStatusPopupOpen && (
                                        <div className="filter-pop-wrapper">
                                            <div
                                                className="cls-btn"
                                                onClick={() => setStatusPopupOpen(false)}
                                            >
                                                <i class="fa-solid fa-xmark"></i>
                                            </div>
                                            <span className="timeline-filter-title">
                                                Event Status Filter
                                            </span>
                                            {/* Arrow */}
                                            <div
                                                style={{
                                                    position: 'absolute',
                                                    bottom: '-10px',
                                                    right: '10px',
                                                    width: 0,
                                                    height: 0,
                                                    borderLeft: '8px solid transparent',
                                                    borderRight: '8px solid transparent',
                                                    borderTop: '10px solid #fff',
                                                }}
                                            />
                                            <div
                                                style={{
                                                    marginTop: '10px',
                                                    fontSize: '13px',
                                                    color: '#2a2a2a',
                                                }}
                                            >
                                                <label className="event-filter-label">
                                                    <input
                                                        type="radio"
                                                        value="all"
                                                        checked={visibilityFilter === 'all'}
                                                        onChange={handleVisibilityChange}
                                                        style={{ marginRight: '6px' }}
                                                    />
                                                    <span
                                                        style={{
                                                            color: '#2a2a2a',
                                                            fontSize: '13px',
                                                        }}
                                                    >
                                                        Show All Events
                                                    </span>
                                                </label>
                                                <label className="event-filter-label">
                                                    <input
                                                        type="radio"
                                                        value="hidden"
                                                        checked={visibilityFilter === 'hidden'}
                                                        onChange={handleVisibilityChange}
                                                        style={{ marginRight: '6px' }}
                                                    />
                                                    <span
                                                        style={{
                                                            color: '#2a2a2a',
                                                            fontSize: '13px',
                                                        }}
                                                    >
                                                        Show Hidden
                                                    </span>
                                                </label>

                                                <label className="event-filter-label">
                                                    <input
                                                        type="radio"
                                                        value="visible"
                                                        checked={visibilityFilter === 'visible'}
                                                        onChange={handleVisibilityChange}
                                                        style={{ marginRight: '6px' }}
                                                    />
                                                    <span
                                                        style={{
                                                            color: '#2a2a2a',
                                                            fontSize: '13px',
                                                        }}
                                                    >
                                                        Hide Hidden
                                                    </span>
                                                </label>
                                            </div>
                                        </div>
                                    )}
                                </div>

                                <div className="p-1" style={{ position: 'relative' }}>
                                    <FiCalendar
                                        className="filter-icons"
                                        title="Filter by Date"
                                        size={18}
                                        onClick={toggleDatePopUp}
                                    />
                                    {isDatePopupOpen && (
                                        <div className="filter-pop-wrapper" >
                                            {/* Close Button */}
                                            <div
                                                className="cls-btn"
                                                onClick={() => setDatePopupOpen(false)}
                                            >
                                                <i class="fa-solid fa-xmark"></i>
                                            </div>
                                            <span className="timeline-filter-title">
                                                Date Filter
                                            </span>
                                            {/* Arrow */}
                                            <div
                                                style={{
                                                    position: 'absolute',
                                                    bottom: '-10px',
                                                    right: '10px',
                                                    width: 0,
                                                    height: 0,
                                                    borderLeft: '8px solid transparent',
                                                    borderRight: '8px solid transparent',
                                                    borderTop: '10px solid #fff',
                                                }}
                                            />

                                            <div className="d-flex flex-column justify-content-between" style={{ height: '84%' }}>
                                                <div className=""
                                                    style={{
                                                        marginTop: '4px',
                                                        color: '#2a2a2a',
                                                        fontSize: '13px',
                                                    }}
                                                >
                                                    <label htmlFor="">
                                                        <span
                                                            style={{
                                                                fontWeight: 'normal',
                                                                color: '#2a2a2a',
                                                            }}
                                                        >
                                                            From:
                                                        </span>

                                                        <input
                                                            type="text"
                                                            placeholder="Month / day / Year"
                                                            value={startDateFilter}
                                                            onChange={handleStartDateChange}
                                                            style={{
                                                                width: '100%',
                                                                marginBottom: '8px',
                                                                padding: '5px',
                                                                borderRadius: '4px',
                                                                border: '1px solid #999',
                                                                backgroundColor: '#f4f4f4',
                                                                color: '#2a2a2a',
                                                            }}
                                                        />
                                                    </label>

                                                    <label>
                                                        <span
                                                            style={{
                                                                fontWeight: 'normal',
                                                                color: '#2a2a2a',
                                                            }}
                                                        >
                                                            To:
                                                        </span>
                                                        <input
                                                            type="text"
                                                            placeholder="Month / day / Year"
                                                            value={endDateFilter}
                                                            onChange={handleEndDateChange}
                                                            style={{
                                                                width: '100%',
                                                                padding: '5px',
                                                                borderRadius: '4px',
                                                                border: '1px solid #999',
                                                                backgroundColor: '#f4f4f4',
                                                                color: '#2a2a2a',
                                                            }}
                                                        />
                                                    </label>


                                                </div>

                                                {/* buttons */}
                                                <div
                                                    style={{
                                                        marginTop: '10px',
                                                        display: 'flex',
                                                        justifyContent: 'space-between',
                                                    }}
                                                >
                                                    <button className="clear-btn"
                                                        onClick={clearDateFilters} >
                                                        Clear
                                                    </button>
                                                    <button
                                                        className="go-btn"
                                                        onClick={handleFilterDateGo}
                                                    >
                                                        Go
                                                        <i class="fa-solid fa-angle-right"></i>
                                                    </button>

                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>

                                <div className="p-1" style={{ position: 'relative' }}>
                                    <FaSearch
                                        className="filter-icons"
                                        title="Filter by Date"
                                        size={18}
                                        onClick={toggleSearchPopUp}
                                    />

                                    {searchPopupOpen && (
                                        <div className="filter-pop-wrapper" >
                                            {/* Close Button */}
                                            <div
                                                className="cls-btn"
                                                onClick={() => setSearchPopupOpen(false)}
                                            >
                                                <i class="fa-solid fa-xmark"></i>
                                            </div>

                                            <span className="timeline-filter-title">
                                                Search / Filter
                                            </span>

                                            <div className="search-filter-inner d-flex flex-column justify-content-between" style={{ height: '84%' }}>
                                                <div>
                                                    <input
                                                        type="text"
                                                        placeholder="keyword1, keyword2, etc.."
                                                        value={searchKeywords}
                                                        onChange={(e) => setSearchKeywords(e.target.value)}
                                                        style={{
                                                            width: '100%',
                                                            marginBottom: '10px',
                                                            padding: '5px',
                                                            borderRadius: '4px',
                                                            border: '1px solid #999',
                                                            backgroundColor: '#f4f4f4',
                                                            color: '#2a2a2a',
                                                        }}
                                                    />


                                                    <div
                                                        style={{
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            color: '#2a2a2a',
                                                        }}
                                                    >
                                                        <label>
                                                            <input
                                                                type="checkbox"
                                                                checked={searchfilters.title}
                                                                onChange={() =>
                                                                    setSearchFilters((prev) => ({
                                                                        ...prev,
                                                                        title: !prev.title,
                                                                    }))
                                                                }
                                                            />
                                                            <span >
                                                                {' '}
                                                                Title
                                                            </span>
                                                        </label>
                                                        <label>
                                                            <input
                                                                type="checkbox"
                                                                checked={searchfilters.provider}
                                                                onChange={() =>
                                                                    setSearchFilters((prev) => ({
                                                                        ...prev,
                                                                        provider: !prev.provider,
                                                                    }))
                                                                }
                                                            />
                                                            <span >
                                                                {' '}
                                                                Provider
                                                            </span>
                                                        </label>
                                                        <label>
                                                            <input
                                                                type="checkbox"
                                                                checked={searchfilters.organization}
                                                                onChange={() =>
                                                                    setSearchFilters((prev) => ({
                                                                        ...prev,
                                                                        organization: !prev.organization,
                                                                    }))
                                                                }
                                                            />
                                                            <span >
                                                                {' '}
                                                                Organization
                                                            </span>
                                                        </label>
                                                    </div>
                                                </div>


                                                {/* buttons */}
                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        justifyContent: 'space-between',
                                                    }}
                                                >
                                                    <button
                                                        className="clear-btn"
                                                        onClick={clearSearch}
                                                    >
                                                        Clear
                                                    </button>
                                                    <button
                                                        className="go-btn"
                                                        onClick={handleSearchGo} >
                                                        Go
                                                        <i class="fa-solid fa-angle-right"></i>
                                                    </button>
                                                </div>
                                            </div>

                                            {/* Arrow */}
                                            <div
                                                style={{
                                                    position: 'absolute',
                                                    bottom: '-10px',
                                                    right: '10px',
                                                    width: 0,
                                                    height: 0,
                                                    borderLeft: '8px solid transparent',
                                                    borderRight: '8px solid transparent',
                                                    borderTop: '10px solid #fff',
                                                }}
                                            />
                                        </div>
                                    )}
                                </div>
                            </div>

                            {/* Modal */}
                            {selectedItem && (
                                <SelecteditemModal
                                    selectedItem={selectedItem}
                                    handleclose={(isedited) => handleCloseSelectedItemModal(isedited)}
                                    caseName={caseName}
                                    selectedpdf={pdf}
                                />
                            )}
                            <Modal show={showPreview} onHide={() => setShowPreview(false)} size="xl" centered>

                                <Modal.Body >
                                    <p>Print Preview</p>
                                    {previewImg && (
                                        <img
                                            src={previewImg}
                                            alt="Preview"
                                            style={{ maxWidth: "100%", border: "1px solid #ccc" }}
                                        />
                                    )}
                                </Modal.Body>

                                <Modal.Footer>
                                    <Button variant="secondary" onClick={() => setShowPreview(false)}>
                                        Cancel
                                    </Button>
                                    <Button className="stay-btn m-0" onClick={handlePrint}>
                                        Print
                                    </Button>
                                </Modal.Footer>
                            </Modal>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TimelineComponent;
